import { useToggle } from "client/hooks/utils/useToggle";

export const useCropImageBottomMenu = () => {
    const { isOpen, open, onClose: close } = useToggle();

    return { isOpen, open, close };
};
